import * as React from 'react';

function SvgChatAI(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      focusable={false}
      style={{ color: props.color, fontSize: props.fontSize }}
      {...props}
    >
      {/* Large 4-pointed sparkle */}
      <path
        d="M13 2l2 6.5L21 11l-6 2.5L13 20l-2-6.5L5 11l6-2.5L13 2z"
        stroke="currentColor"
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      {/* Small 4-pointed sparkle at bottom-left */}
      <path
        d="M5.5 17l.75 2.25L8.5 20l-2.25.75L5.5 23l-.75-2.25L2.5 20l2.25-.75L5.5 17z"
        stroke="currentColor"
        strokeWidth={1.2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export default SvgChatAI;
